import importerReducers from '../../../modules/shared/importer/importerReducers'
import actions from '../../../modules/posts/importer/postsImporterActions'

export default importerReducers(actions)
